import styled from 'styled-components';

export default styled.div`
  min-height: 75vh;
  padding-bottom: 48px;
  ${(props) => ({ ...props.theme })};
`;
